import styled, { css } from "styled-components";

export const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Tag = styled.span<{ $isDarker?: boolean }>`
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  min-width: fit-content;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: #f4f5f6;
  color: #808893;
  font-size: 10px;
  line-height: normal;
  z-index: 10;

  ${({ $isDarker }) =>
    $isDarker &&
    css`
      background: #dee0e3;
      color: #50565e;
    `}

  svg {
    color: #808893;
    width: 12px;
    height: 12px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 12px;
`;
